import editorPackage from '../../../package.json';

const raw = (editorPackage as { version?: unknown }).version;

/**
 * Version string from the editor package, for Sentry tags. Safe for empty/missing JSON.
 */
export const EDITOR_PACKAGE_VERSION: string =
  typeof raw === 'string' && raw.length > 0 ? raw : 'unknown';
